<template>
  <div>
    <div v-if="!edit" class="wg-row wg-p-xs-20" style="margin-bottom: 10px">
      <div class="wg-row" style="align-items: center">
        <input
          id="personal-check"
          type="radio"
          :value="1"
          style="display: none"
          v-model="personal"
        />
        <label class="label-input-radio" for="personal-check">{{
          personal ? "✔" : ""
        }}</label>
        <div class="com-anm22-app-text-l" style="margin: 0 5px">
          {{ $anm22.strLang(lang, "Sent", "Inviato") }}
        </div>
        <div class="com-anm22-horizontal-div" style="width: 20px"></div>
        <input
          id="received-check"
          type="radio"
          :value="0"
          style="display: none"
          v-model="personal"
        />
        <label class="label-input-radio" for="received-check">{{
          !personal ? "✔" : ""
        }}</label>
        <div class="com-anm22-app-text-l" style="margin: 0 5px">
          {{ $anm22.strLang(lang, "Received", "Ricevuto") }}
        </div>
      </div>
    </div>
    <!-- Tipo di elemento -->
    <div class="wg-row" style="margin-bottom: 20px">
      <div
        v-for="(type, index) in types.filter((t) =>
          edit
            ? onlyReminderView
              ? t.id == 'reminder'
              : t.id != 'reminder'
            : t
        )"
        :key="'type-' + index"
        :class="['type-icon-div', type.id === msg.data.type ? 'selected' : '']"
        @click="msg.data.type = type.id"
      >
        <img
          class="type-icon"
          :style="{ backgroundColor: type.bgColor }"
          :src="$anm22.icons.getWorldIcon(type.icon)"
        />
      </div>
    </div>
    <div class="wg-row" style="margin-bottom: 10px">
      <div class="wg-col wg-xs-12 wg-sm-5 wg-p-xs-20">
        <template v-if="msg.data.type === 'call'">
          <!-- Da -->
          <div class="wg-row input-row">
            <div class="wg-col wg-xs-6 wg-sm-4 com-anm22-app-text-m">
              {{ $anm22.strLang(lang, "From", "Da") }}
            </div>
            <div class="wg-col wg-xs-5 wg-sm-7">
              <input
                v-if="modeFrom == 'new'"
                class="com-anm22-app-input-text"
                type="text"
                :placeholder="
                  $anm22.strLang(lang, 'Number / ID', 'Numero / ID')
                "
                v-model="msg.data.from"
              />
              <select
                v-else
                class="com-anm22-app-select"
                v-model="msg.data.from"
              >
                <option value></option>
                <option
                  v-for="(c, index) in allContacts.filter(
                    (c) => !c.label.email
                  )"
                  :key="'from-' + index"
                  :value="
                    c.label.email
                      ? c.label.email
                      : c.label.phoneAreaCode + c.label.phoneNumber
                  "
                >
                  {{
                    c.label.email
                      ? c.label.email
                      : c.label.phoneAreaCode + " " + c.label.phoneNumber
                  }}
                </option>
              </select>
            </div>
            <img
              :src="$anm22.icons.getWorldIcon('menuSwitch')"
              @click="
                modeFrom == 'select'
                  ? (modeFrom = 'new')
                  : (modeFrom = 'select')
              "
              style="
                display: inline-block;
                width: 20px;
                margin-top: -7px;
                margin-left: 5px;
                opacity: 0.7;
                cursor: pointer;
              "
            />
          </div>
          <!-- A -->
          <div class="wg-row input-row">
            <div class="wg-col wg-xs-6 wg-sm-4 com-anm22-app-text-m">
              {{ $anm22.strLang(lang, "To", "A") }}
            </div>
            <div class="wg-col wg-xs-5 wg-sm-7">
              <input
                v-if="modeTo == 'new'"
                class="com-anm22-app-input-text"
                type="text"
                :placeholder="
                  $anm22.strLang(lang, 'Number / ID', 'Numero / ID')
                "
                v-model="msg.data.to"
              />
              <select v-else class="com-anm22-app-select" v-model="msg.data.to">
                <option value></option>
                <option
                  v-for="(c, index) in allContacts.filter(
                    (c) => !c.label.email
                  )"
                  :key="'to-' + index"
                  :value="
                    c.label.email
                      ? c.label.email
                      : c.label.phoneAreaCode + c.label.phoneNumber
                  "
                >
                  {{
                    c.label.email
                      ? c.label.email
                      : c.label.phoneAreaCode + " " + c.label.phoneNumber
                  }}
                </option>
              </select>
            </div>
            <img
              :src="$anm22.icons.getWorldIcon('menuSwitch')"
              @click="
                modeTo == 'select' ? (modeTo = 'new') : (modeTo = 'select')
              "
              style="
                display: inline-block;
                width: 20px;
                margin-top: -7px;
                margin-left: 5px;
                opacity: 0.7;
                cursor: pointer;
              "
            />
          </div>
          <!-- Esito chiamata -->
          <div class="wg-row input-row">
            <div class="wg-col wg-xs-6 wg-sm-4 com-anm22-app-text-m">
              {{ $anm22.strLang(lang, "Outcome", "Esito") }}
            </div>
            <div class="wg-col wg-xs-6 wg-sm-8">
              <select class="com-anm22-app-select" v-model="callOutcomeComputed">
                <option
                  v-for="(o, index) in callOutcomes"
                  :key="'o-' + index"
                  :value="o.id"
                >
                  {{ o.label }}
                </option>
              </select>
            </div>
          </div>
          <!-- Category -->
          <div class="wg-row input-row">
            <div class="wg-col wg-xs-6 wg-sm-4 com-anm22-app-text-m">
              {{ $anm22.strLang(lang, "Channel", "Canale") }}
            </div>
            <div class="wg-col wg-xs-6 wg-sm-8">
              <select class="com-anm22-app-select" v-model="category">
                <option value="other">
                  {{ $anm22.strLang(lang, "Not specified", "Non specificato") }}
                </option>
                <option
                  v-for="(c, index) in categories.filter((c) =>
                    c.type.includes('call')
                  )"
                  :key="'category-' + index"
                  :value="c.id"
                >
                  {{ c.label }}
                </option>
              </select>
            </div>
          </div>
          <!-- DATA/ORA -->
          <div class="wg-row input-row">
            <div class="wg-col wg-xs-6 wg-sm-4 com-anm22-app-text-m">
              {{ $anm22.strLang(lang, "Date", "Data") }}
            </div>
            <div class="wg-col wg-xs-6 wg-sm-8">
              <input
                class="com-anm22-app-input-date"
                type="date"
                v-model.lazy="msgDate"
              />
            </div>
          </div>
          <div class="wg-row input-row">
            <div class="wg-col wg-xs-6 wg-sm-4 com-anm22-app-text-m">
              {{ $anm22.strLang(lang, "Time", "Ora") }}
            </div>
            <div class="wg-col wg-xs-6 wg-sm-8">
              <input
                class="com-anm22-app-input-time"
                type="time"
                v-model.lazy="msgTime"
              />
            </div>
          </div>
          <!-- Durata -->
          <div class="wg-row input-row">
            <div class="wg-col wg-xs-6 wg-sm-4 com-anm22-app-text-m">
              {{ $anm22.strLang(lang, "Duration", "Durata") }}
            </div>
            <div class="wg-col wg-xs-6 wg-sm-8">
              <input
                class="com-anm22-app-input-text"
                type="text"
                :placeholder="'hh:mm'"
                :value="duration"
                @focus="durationToExpr"
                @blur="parseDuration($event.target.value)"
              />
            </div>
          </div>
          <div
            v-if="
              contact.workOwner &&
              contact.workOwner != 0 &&
              contactsStatus.length > 0 &&
              !edit
            "
            class="wg-row input-row"
            style="align-items: center; justify-content: space-between"
          >
            <div class="wg-col wg-xs-6 wg-sm-3 com-anm22-app-text-m">
              {{ $anm22.strLang(lang, "Contact status", "Stato contatto") }}
            </div>
            <div class="wg-col wg-xs-6 wg-sm-8">
              <select
                class="input-elem com-anm22-app-select"
                v-model="selectedContactStatus"
              >
                <option value>
                  {{ $anm22.strLang(lang, "No status", "Nessuno stato") }}
                </option>
                <option
                  v-for="(status, index) in orderedContactsStatusList"
                  :key="'status-' + index"
                  :value="status.idContactsContactStatus"
                >
                  {{ status.name }}
                </option>
              </select>
            </div>
          </div>
        </template>
        <template v-else-if="msg.data.type === 'msg'">
          <!-- Da -->
          <div class="wg-row input-row">
            <div class="wg-col wg-xs-6 wg-sm-4 com-anm22-app-text-m">
              {{ $anm22.strLang(lang, "From", "Da") }}
            </div>
            <div class="wg-col wg-xs-5 wg-sm-7">
              <input
                v-if="modeFrom == 'new'"
                class="com-anm22-app-input-text"
                type="text"
                :placeholder="
                  $anm22.strLang(lang, 'Number / ID', 'Numero / ID')
                "
                v-model="msg.data.from"
              />
              <select
                v-else
                class="com-anm22-app-select"
                v-model="msg.data.from"
              >
                <option value></option>
                <option
                  v-for="(c, index) in allContacts"
                  :key="'from-' + index"
                  :value="
                    c.label.email
                      ? c.label.email
                      : c.label.phoneAreaCode + c.label.phoneNumber
                  "
                >
                  {{
                    c.label.email
                      ? c.label.email
                      : c.label.phoneAreaCode + " " + c.label.phoneNumber
                  }}
                </option>
              </select>
            </div>
            <img
              :src="$anm22.icons.getWorldIcon('menuSwitch')"
              @click="
                modeFrom == 'select'
                  ? (modeFrom = 'new')
                  : (modeFrom = 'select')
              "
              style="
                display: inline-block;
                width: 20px;
                margin-top: -7px;
                margin-left: 5px;
                opacity: 0.7;
                cursor: pointer;
              "
            />
          </div>
          <!-- A -->
          <div class="wg-row input-row">
            <div class="wg-col wg-xs-6 wg-sm-4 com-anm22-app-text-m">
              {{ $anm22.strLang(lang, "To", "A") }}
            </div>
            <div class="wg-col wg-xs-5 wg-sm-7">
              <input
                v-if="modeTo == 'new'"
                class="com-anm22-app-input-text"
                type="text"
                :placeholder="
                  $anm22.strLang(lang, 'Number / ID', 'Numero / ID')
                "
                v-model="msg.data.to"
              />
              <select v-else class="com-anm22-app-select" v-model="msg.data.to">
                <option value></option>
                <option
                  v-for="(c, index) in allContacts"
                  :key="'from-' + index"
                  :value="
                    c.label.email
                      ? c.label.email
                      : c.label.phoneAreaCode + c.label.phoneNumber
                  "
                >
                  {{
                    c.label.email
                      ? c.label.email
                      : c.label.phoneAreaCode + " " + c.label.phoneNumber
                  }}
                </option>
              </select>
            </div>
            <img
              :src="$anm22.icons.getWorldIcon('menuSwitch')"
              @click="
                modeTo == 'select' ? (modeTo = 'new') : (modeTo = 'select')
              "
              style="
                display: inline-block;
                width: 20px;
                margin-top: -7px;
                margin-left: 5px;
                opacity: 0.7;
                cursor: pointer;
              "
            />
          </div>
          <!-- Category -->
          <div class="wg-row input-row">
            <div class="wg-col wg-xs-6 wg-sm-4 com-anm22-app-text-m">
              {{ $anm22.strLang(lang, "Channel", "Canale") }}
            </div>
            <div class="wg-col wg-xs-6 wg-sm-8">
              <select class="com-anm22-app-select" v-model="category">
                <option value="other">
                  {{ $anm22.strLang(lang, "Not specified", "Non specificato") }}
                </option>
                <option
                  v-for="(c, index) in categories.filter((c) =>
                    c.type.includes('msg')
                  )"
                  :key="'category-' + index"
                  :value="c.id"
                >
                  {{ c.label }}
                </option>
              </select>
            </div>
          </div>
          <!-- DATA/ORA -->
          <div class="wg-row input-row">
            <div class="wg-col wg-xs-6 wg-sm-4 com-anm22-app-text-m">
              {{ $anm22.strLang(lang, "Date", "Data") }}
            </div>
            <div class="wg-col wg-xs-6 wg-sm-8">
              <input
                class="com-anm22-app-input-date"
                type="date"
                v-model.lazy="msgDate"
              />
            </div>
          </div>
          <div class="wg-row input-row">
            <div class="wg-col wg-xs-6 wg-sm-4 com-anm22-app-text-m">
              {{ $anm22.strLang(lang, "Time", "Ora") }}
            </div>
            <div class="wg-col wg-xs-6 wg-sm-8">
              <input
                class="com-anm22-app-input-time"
                type="time"
                v-model.lazy="msgTime"
              />
            </div>
          </div>
          <!-- OGGETTO -->
          <div class="wg-row input-row">
            <div class="wg-col wg-xs-6 wg-sm-4 com-anm22-app-text-m">
              {{ $anm22.strLang(lang, "Subject", "Oggetto") }}
            </div>
            <div class="wg-col wg-xs-6 wg-sm-8">
              <input
                class="com-anm22-app-input-text"
                type="text"
                :placeholder="$anm22.strLang(lang, 'Subject', 'Oggetto')"
                v-model="msg.data.subject"
              />
            </div>
          </div>
          <div
            v-if="
              contact.workOwner &&
              contact.workOwner != 0 &&
              contactsStatus.length > 0
            "
            class="wg-row input-row"
            style="align-items: center; justify-content: space-between"
          >
            <div class="wg-col wg-xs-6 wg-sm-3 com-anm22-app-text-m">
              {{ $anm22.strLang(lang, "Contact status", "Stato contatto") }}
            </div>
            <div class="wg-col wg-xs-6 wg-sm-8">
              <select
                class="input-elem com-anm22-app-select"
                v-model="selectedContactStatus"
              >
                <option value>
                  {{ $anm22.strLang(lang, "No status", "Nessuno stato") }}
                </option>
                <option
                  v-for="(status, index) in orderedContactsStatusList"
                  :key="'status-' + index"
                  :value="status.idContactsContactStatus"
                >
                  {{ status.name }}
                </option>
              </select>
            </div>
          </div>
        </template>
        <template v-else-if="msg.data.type === 'meeting'">
          <!-- Partecipanti -->
          <div class="wg-row input-row">
            <div class="wg-col wg-xs-6 wg-sm-4 com-anm22-app-text-m">
              {{ $anm22.strLang(lang, "Attending", "Partecipanti") }}
            </div>
            <div class="wg-col wg-xs-6 wg-sm-8">
              <input
                class="com-anm22-app-input-text"
                type="text"
                v-model="msg.data.participants"
              />
            </div>
          </div>
          <!-- Luogo -->
          <div class="wg-row input-row">
            <div class="wg-col wg-xs-6 wg-sm-4 com-anm22-app-text-m">
              {{ $anm22.strLang(lang, "Location", "Luogo") }}
            </div>
            <div class="wg-col wg-xs-6 wg-sm-8">
              <input
                class="com-anm22-app-input-text"
                type="text"
                v-model="msg.data.location"
              />
            </div>
          </div>
          <!-- DATA/ORA -->
          <div class="wg-row input-row">
            <div class="wg-col wg-xs-6 wg-sm-4 com-anm22-app-text-m">
              {{ $anm22.strLang(lang, "Date", "Data") }}
            </div>
            <div class="wg-col wg-xs-6 wg-sm-8">
              <input
                class="com-anm22-app-input-date"
                type="date"
                v-model.lazy="msgDate"
              />
            </div>
          </div>
          <div class="wg-row input-row">
            <div class="wg-col wg-xs-6 wg-sm-4 com-anm22-app-text-m">
              {{ $anm22.strLang(lang, "Time", "Ora") }}
            </div>
            <div class="wg-col wg-xs-6 wg-sm-8">
              <input
                class="com-anm22-app-input-time"
                type="time"
                v-model.lazy="msgTime"
              />
            </div>
          </div>
          <!-- Durata -->
          <div class="wg-row input-row">
            <div class="wg-col wg-xs-6 wg-sm-4 com-anm22-app-text-m">
              {{ $anm22.strLang(lang, "Duration", "Durata") }}
            </div>
            <div class="wg-col wg-xs-6 wg-sm-8">
              <input
                class="com-anm22-app-input-text"
                type="text"
                :placeholder="'hh:mm'"
                :value="duration"
                @focus="durationToExpr"
                @blur="parseDuration($event.target.value)"
              />
            </div>
          </div>
          <div
            v-if="
              contact.workOwner &&
              contact.workOwner != 0 &&
              contactsStatus.length > 0
            "
            class="wg-row input-row"
            style="align-items: center; justify-content: space-between"
          >
            <div class="wg-col wg-xs-6 wg-sm-3 com-anm22-app-text-m">
              {{ $anm22.strLang(lang, "Contact status", "Stato contatto") }}
            </div>
            <div class="wg-col wg-xs-6 wg-sm-8">
              <select
                class="input-elem com-anm22-app-select"
                v-model="selectedContactStatus"
              >
                <option value>
                  {{ $anm22.strLang(lang, "No status", "Nessuno stato") }}
                </option>
                <option
                  v-for="(status, index) in orderedContactsStatusList"
                  :key="'status-' + index"
                  :value="status.idContactsContactStatus"
                >
                  {{ status.name }}
                </option>
              </select>
            </div>
          </div>
        </template>
        <template v-else-if="msg.data.type === 'reminder'">
          <div class="wg-row input-row">
            <div class="wg-col wg-xs-6 wg-sm-4 com-anm22-app-text-m">
              {{ $anm22.strLang(lang, "Name", "Nome") }}
            </div>
            <div class="wg-col wg-xs-6 wg-sm-8">
              <input
                :disabled="onlyReminderView"
                class="com-anm22-app-input-text"
                type="text"
                v-model="msg.data.name"
              />
            </div>
          </div>
          <!-- DATA/ORA -->
          <div class="wg-row input-row">
            <div class="wg-col wg-xs-6 wg-sm-4 com-anm22-app-text-m">
              {{ $anm22.strLang(lang, "Date", "Data") }}
            </div>
            <div class="wg-col wg-xs-6 wg-sm-8">
              <input
                class="com-anm22-app-input-date"
                type="date"
                :disabled="onlyReminderView"
                v-model.lazy="msgDate"
              />
            </div>
          </div>
          <div class="wg-row input-row">
            <div class="wg-col wg-xs-6 wg-sm-4 com-anm22-app-text-m">
              {{ $anm22.strLang(lang, "Time", "Ora") }}
            </div>
            <div class="wg-col wg-xs-6 wg-sm-8">
              <input
                class="com-anm22-app-input-time"
                type="time"
                :disabled="onlyReminderView"
                v-model.lazy="msgTime"
              />
            </div>
          </div>
          <div class="wg-row input-row">
            <div class="wg-col wg-xs-6 wg-sm-4 com-anm22-app-text-m">
              {{ $anm22.strLang(lang, "In pause", "In pausa") }}
            </div>
            <div class="wg-col wg-xs-6 wg-sm-8">
              <input
                :disabled="onlyReminderView"
                id="in-pause"
                type="checkbox"
                :value="1"
                style="display: none"
                v-model="inPause"
              />
              <label class="label-input-radio" for="in-pause">{{
                inPause ? "✔" : ""
              }}</label>
            </div>
          </div>
        </template>
        <template v-else-if="msg.data.type === 'changeStatus'">
          <!-- DATA/ORA -->
          <div class="wg-row input-row">
            <div class="wg-col wg-xs-6 wg-sm-4 com-anm22-app-text-m">
              {{ $anm22.strLang(lang, "Date", "Data") }}
            </div>
            <div class="wg-col wg-xs-6 wg-sm-8">
              <input
                class="com-anm22-app-input-date"
                type="date"
                disabled
                v-model.lazy="msgDate"
              />
            </div>
          </div>
          <div class="wg-row input-row">
            <div class="wg-col wg-xs-6 wg-sm-4 com-anm22-app-text-m">
              {{ $anm22.strLang(lang, "Time", "Ora") }}
            </div>
            <div class="wg-col wg-xs-6 wg-sm-8">
              <input
                class="com-anm22-app-input-time"
                type="time"
                disabled
                v-model.lazy="msgTime"
              />
            </div>
          </div>
        </template>
      </div>
      <div class="wg-col wg-xs-12 wg-sm-7 wg-p-xs-20">
        <div class="com-anm22-app-text-m" style="margin-bottom: 5px">
          {{
            msg.data.type === "msg"
              ? $anm22.strLang(lang, "Text", "Testo")
              : $anm22.strLang(lang, "Description", "Descrizione")
          }}
        </div>
        <textarea
          :disabled="onlyReminderView || changeStatusView"
          class="description"
          v-model="description"
        ></textarea>
      </div>
      <template v-if="msg.data.type != 'reminder' && !this.edit">
        <div class="wg-row">
          <div
            :class="['reminder-label', addReminder ? 'selected' : '']"
            @click="addReminder = !addReminder"
          >
            <div class="name">
              {{ $anm22.strLang(lang, "Add reminder", "Crea promemoria") }}
            </div>
            <img
              :src="
                addReminder
                  ? $anm22.icons.getWorldIcon('reminderWhite')
                  : $anm22.icons.getWorldIcon('reminder')
              "
              class="com-anm22-app-img-s img"
              style="opacity: 0.6"
            />
          </div>
        </div>
        <template v-if="addReminder">
          <div class="wg-col wg-xs-12 wg-sm-5 wg-p-xs-20">
            <div class="wg-row input-row">
              <div class="wg-col wg-xs-6 wg-sm-4 com-anm22-app-text-m">
                {{ $anm22.strLang(lang, "Name", "Nome") }}
              </div>
              <div class="wg-col wg-xs-6 wg-sm-8">
                <input
                  class="com-anm22-app-input-text"
                  type="text"
                  v-model="newReminder.data.name"
                />
              </div>
            </div>
            <!-- DATA/ORA -->
            <div class="wg-row input-row">
              <div class="wg-col wg-xs-6 wg-sm-4 com-anm22-app-text-m">
                {{ $anm22.strLang(lang, "Date", "Data") }}
              </div>
              <div class="wg-col wg-xs-6 wg-sm-8">
                <input
                  class="com-anm22-app-input-date"
                  type="date"
                  v-model.lazy="msgReminderDate"
                />
              </div>
            </div>
            <div class="wg-row input-row">
              <div class="wg-col wg-xs-6 wg-sm-4 com-anm22-app-text-m">
                {{ $anm22.strLang(lang, "Time", "Ora") }}
              </div>
              <div class="wg-col wg-xs-6 wg-sm-8">
                <input
                  class="com-anm22-app-input-time"
                  type="time"
                  v-model.lazy="msgReminderTime"
                />
              </div>
            </div>
            <div class="wg-row input-row">
              <div class="wg-col wg-xs-6 wg-sm-4 com-anm22-app-text-m">
                {{ $anm22.strLang(lang, "In pause", "In pausa") }}
              </div>
              <div class="wg-col wg-xs-6 wg-sm-8">
                <input
                  id="in-pause-rem"
                  type="checkbox"
                  :value="1"
                  style="display: none"
                  v-model="inPauseRem"
                />
                <label class="label-input-radio" for="in-pause-rem">{{
                  inPauseRem ? "✔" : ""
                }}</label>
              </div>
            </div>
          </div>
          <div class="wg-col wg-xs-12 wg-sm-7 wg-p-xs-20">
            <div class="com-anm22-app-text-m" style="margin-bottom: 5px">
              {{ $anm22.strLang(lang, "Description", "Descrizione") }}
            </div>
            <textarea
              class="description"
              v-model="newReminder.data.description"
            ></textarea>
          </div>
        </template>
      </template>
    </div>
    <div v-if="edit" class="wg-row input-row">
      <div class="wg-col wg-xs-12 wg-sm-6">
        <div class="com-anm22-app-text-m">
          {{ $anm22.strLang(lang, "Last edit", "Ultima modifica ") }}
        </div>
      </div>
      <div class="vertical-height-div wg-sm-none" style="height: 10px"></div>
      <div class="wg-col wg-xs-12 wg-sm-6">
        <div class="com-anm22-app-text-m">
          {{ lastEditDate + " " + lastEditUser }}
        </div>
      </div>
    </div>
    <div class="vertical-height-div" style="height: 10px"></div>
    <div class="wg-row">
      <input
        v-if="!onlyReminderView"
        type="button"
        class="small"
        :value="$anm22.strLang(lang, 'Save', 'Salva')"
        @click="saveItem"
      />
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  props: {
    contactId: [String, Number],
    edit: {
      type: Boolean,
      default: false,
    },
    onlyReminderView: {
      type: Boolean,
      default: false,
    },
    changeStatusView: {
      type: Boolean,
      default: false,
    },
    msgRef: {
      type: Object,
      default: function () {
        return {
          data: {
            text: "",
            description: "",
            type: "call",
            contentType: "plain",
          },
          ts: this.$moment().unix(),
        };
      }
    }
  },
  data() {
    return {
      newReminder: {
        data: {
          text: "",
          description: "",
          type: "reminder",
          contentType: "plain"
        },
        ts: this.$moment().unix()
      },
      nowTimestamp: this.$moment().unix(),
      category: "other",
      inPause: true,
      inPauseRem: true,
      oldContactStatus: "",
      selectedContactStatus: "",
      addReminder: false,
      modeFrom: "select",
      modeTo: "select",
      callOutcome: "replied",
      allContacts: [],
      msg: JSON.parse(JSON.stringify(this.msgRef)),
      personal: 1,
      duration: ""
    };
  },
  computed: {
    ...mapState({
      lang: (state) => state.lang,
      user: (state) => state.auth.user
    }),
    types() {
      let types = [
        {
          id: "call",
          icon: "phoneWhite",
          bgColor: "orange"
        },
        {
          id: "msg",
          icon: "chatWhite",
          bgColor: "#0aabf4"
        },
        {
          id: "meeting",
          icon: "placeWhite",
          bgColor: "red"
        },
        {
          id: "reminder",
          icon: "reminderWhite",
          bgColor: "#777777"
        },
      ];
      if (this.changeStatusView) {
        types.push({
          id: "changeStatus",
          icon: "viewCols",
          bgColor: "white"
        });
        return types.filter((t) => t.id == "changeStatus");
      } else {
        return types;
      }
    },
    contactsStatus() {
      return this.$store.getters["contactsStatus/getByWork"](
        this.contact.workOwner
      );
    },
    orderedContactsStatusList() {
      var status = this.contactsStatus;
      status.sort(function (a, b) {
        if (a.level < b.level) {
          return -1;
        } else if (a.level > b.level) {
          return 1;
        } else {
          return 0;
        }
      });
      return status;
    },
    statusChangedText() {
      let text = "";
      //VECCHIO STATO
      let fromStatus = this.$store.getters["contactsStatus/get"](
        this.oldContactStatus
      );
      //STATO SELEZIONATO
      let toStatus = this.$store.getters["contactsStatus/get"](
        this.selectedContactStatus
      );
      if (!fromStatus && toStatus) {
        text = this.$anm22.strLang(
          this.lang,
          "Contact added to" + " " + toStatus.name,
          "Contatto aggiunto in" + " " + toStatus.name
        );
      } else if (fromStatus && !toStatus) {
        text = this.$anm22.strLang(
          this.lang,
          "Contact status removed ",
          "Stato del contatto rimosso"
        );
      } else if (fromStatus && toStatus) {
        text = this.$anm22.strLang(
          this.lang,
          "Contact status changed to" + " " + toStatus.name,
          "Lo stato del contatto è cambiato in" + " " + toStatus.name
        );
      }
      return text;
    },
    callOutcomes() {
      return [
        {
          id: "replied",
          label: this.$anm22.strLang(this.lang, "Replied", "Risposto"),
        },
        {
          id: "notreplied",
          label: this.$anm22.strLang(this.lang, "Not replied", "Non risposto"),
        },
        {
          id: "notexist",
          label: this.$anm22.strLang(
            this.lang,
            "Number not existing",
            "Numero non esistente"
          )
        }
      ];
    },
    categories() {
      return [
        {
          id: "whatsapp",
          label: "Whatsapp",
          type: ["msg"]
        },
        {
          id: "fb",
          label: "Facebook",
          type: ["msg"]
        },
        {
          id: "messenger",
          label: "Messenger",
          type: ["msg", "call"]
        },
        {
          id: "zoom",
          label: "Zoom",
          type: ["msg", "call"]
        },
        {
          id: "discord",
          label: "Discord",
          type: ["msg", "call"]
        },
        {
          id: "sms",
          label: "Sms",
          type: ["msg"]
        },
        {
          id: "email",
          label: "Email",
          type: ["msg"]
        },
        {
          id: "ig",
          label: "Instagram",
          type: ["msg"]
        },
        {
          id: "hang",
          label: "Hangouts",
          type: ["msg", "call"]
        },
        {
          id: "skype",
          label: "Skype",
          type: ["msg", "call"]
        },
        {
          id: "teams",
          label: "Microsoft Teams",
          type: ["msg", "call"]
        },
        {
          id: "linkedin",
          label: "Linkedin",
          type: ["msg"]
        },
        {
          id: "twitter",
          label: "X",
          type: ["msg"]
        },
        {
          id: "slack",
          label: "Slack",
          type: ["msg", "call"]
        },
        {
          id: "meet",
          label: "Google Meet",
          type: ["msg", "call"]
        }
      ];
    },
    contact() {
      return this.$store.getters["contacts/get"](this.contactId);
    },
    contacts() {
      return this.$store.getters["contacts/getAll"];
    },
    lastEditUser() {
      const user = this.$store.getters["users/get"](this.msg.data.lastUser);
      return user ? user.name + " " + user.surname : "";
    },
    lastEditDate() {
      return this.msg.data.lastUpdate
        ? this.$moment.unix(this.msg.data.lastUpdate).format("DD/MM/YYYY HH:mm")
        : "";
    },
    callOutcomeComputed :  {
      get() {
        return this.callOutcome;
      },
      set(newValue) {
        if(newValue == 'notreplied') {
          this.newReminder.ts = this.msg.ts + 12600
          this.addReminder = true;
        } else {
          this.addReminder = false;
        }
        this.callOutcome = newValue;
      }
    },
    msgDate: {
      get() {
        if (this.msg.ts) {
          return this.$moment.unix(this.msg.ts).format("YYYY-MM-DD");
        } else {
          return "";
        }
      },
      set(newDate) {
        const toParse = (newDate + " " + this.msgTime).trim();
        let ts = Number(this.$moment(toParse).utc().format("X"));
        if (isNaN(ts)) {
          this.$set(this.msg, "ts", "");
        } else if (ts) {
          this.$set(this.msg, "ts", ts);
          if(this.callOutcome == 'notreplied') {
            this.newReminder.ts = ts + 12600;
          }
        }
      }
    },
    msgReminderDate: {
      get() {
        if (this.newReminder.ts) {
          return this.$moment.unix(this.newReminder.ts).format("YYYY-MM-DD");
        } else {
          return "";
        }
      },
      set(newDate) {
        const toParse = (newDate + " " + this.msgReminderTime).trim();
        let ts = Number(this.$moment(toParse).utc().format("X"));
        if (isNaN(ts)) {
          this.$set(this.newReminder, "ts", "");
        } else if (ts) {
          this.$set(this.newReminder, "ts", ts);
        }
      }
    },
    msgReminderTime: {
      get() {
        if (this.msg.ts) {
          return this.$moment.unix(this.newReminder.ts).format("HH:mm");
        } else {
          return "";
        }
      },
      set(newTime) {
        const toParse = (this.msgReminderDate + " " + newTime).trim();
        let ts = Number(this.$moment(toParse).utc().format("X"));
        if (isNaN(ts)) {
          this.$set(this.newReminder, "ts", "");
        } else if (ts) {
          this.$set(this.newReminder, "ts", ts);
        }
      }
    },
    msgTime: {
      get() {
        if (this.msg.ts) {
          return this.$moment.unix(this.msg.ts).format("HH:mm");
        } else {
          return "";
        }
      },
      set(newTime) {
        const toParse = (this.msgDate + " " + newTime).trim();
        let ts = Number(this.$moment(toParse).utc().format("X"));
        if (isNaN(ts)) {
          this.$set(this.msg, "ts", "");
        } else if (ts) {
          this.$set(this.msg, "ts", ts);
          if(this.callOutcome == 'notreplied') {
            this.newReminder.ts = ts + 12600;
          }
        }
      }
    },
    description: {
      get() {
        return this.msg.data.type === "msg" ||
          this.msg.data.type == "changeStatus"
          ? this.msg.data.text
          : this.msg.data.description;
      },
      set(newVal) {
        if (this.msg.data.type === "msg") {
          this.msg.data.text = newVal;
        } else {
          this.msg.data.description = newVal;
        }
      }
    },
    companyContact() {
      if (
        this.contact.type == 1 &&
        this.contact.company &&
        this.contact.company != ""
      ) {
        const companyContact = this.contacts.find(
          (c) =>
            c.type == 2 &&
            c.workOwner == this.contact.workOwner &&
            c.firstName.toUpperCase() == this.contact.company.toUpperCase()
        );
        if (companyContact) {
          return companyContact;
        }
      }
    },
  },
  methods: {
    async saveItem() {
      if (this.edit == false) {
        this.msg.idWorldMessage = this.msg.dbKey = this.$anm22.genLocalId();
        if (this.personal) {
          this.msg.user = this.user.idWorldUser;
        } else {
          this.msg.contact = this.contact.idContactsContact;
        }
      }
      let addReminder = false;
      let newReminder = {};
      if (
        this.edit == false &&
        this.msg.data.type != "reminder" &&
        this.addReminder
      ) {
        newReminder = { ...this.newReminder };
        addReminder = true;
        newReminder.idWorldMessage = newReminder.dbKey = this.$anm22.genLocalId();
        newReminder.user = this.user.idWorldUser;
        newReminder.createdBy = this.user.idWorldUser;
        newReminder.channel = this.contact.feed;
        /* Aggiungo un secondo in modo che quando viene aggiunto un promemoria assieme a un feed nello stesso orario,il promemoria venga inserito dopo */
        newReminder.ts = newReminder.ts + 1;
      }
      //Tipo risposta
      this.msg.data.callResponse = this.callOutcome;
      //Modalità selezione Da/A
      this.msg.data.modeFrom = this.modeFrom;
      //Categoria
      let categoryObj = this.categories.find((c) => c.id == this.category);
      if (categoryObj && categoryObj.type.includes(this.msg.data.type)) {
        this.msg.data.category = this.category;
      } else {
        this.msg.data.category = "other";
      }
      let pauseDate = null;
      //Aggiorno messaggio
      this.msg.data.modeTo = this.modeTo;
      this.msg.data.lastUser = this.user.idWorldUser;
      this.msg.data.lastUpdate = this.$moment().unix();
      //Aggiorno contatto
      this.contact.lastOpen = this.$moment().unix();
      this.contact.lastFeedUpdate = this.$moment().unix();
      this.contact.lastFeedDate = this.getLastFeedDate(this.contact, this.msg);
      if (this.inPause && this.msg.data.type == "reminder") {
        this.contact.pauseDate = this.msg.ts;
        pauseDate = this.msg.ts;
      }
      if (this.inPauseRem && addReminder && this.msg.data.type != "reminder") {
        this.contact.pauseDate = newReminder.ts;
        pauseDate = newReminder.ts;
      }
      this.$store.dispatch("contacts/update", {
        vlf: this.$vlf("contacts"),
        objs: [this.contact],
      });
      //Oggetto messaggio da inserire nell'eventuale feed del contatto azienda associato
      let msgCompany = {};
      //Se c'è il contatto aziendale ed è un nuovo feed
      if (this.companyContact && !this.edit) {
        msgCompany = { ...this.msg };
        msgCompany.idWorldMessage = msgCompany.dbKey = this.$anm22.genLocalId();
        msgCompany.channel = this.companyContact.feed;
        if (this.inPause && this.msg.data.type == "reminder") {
          this.companyContact.pauseDate = pauseDate;
        }
        //Creazione rapida reminder contatto aziendale
        if (addReminder && this.msg.data.type != "reminder") {
          if (this.inPauseRem) {
            this.companyContact.pauseDate = pauseDate;
          }
          let newCompanyReminder = {};
          newCompanyReminder = { ...this.newReminder };
          newCompanyReminder.idWorldMessage = newCompanyReminder.dbKey = this.$anm22.genLocalId();
          newCompanyReminder.user = this.user.idWorldUser;
          newCompanyReminder.createdBy = this.user.idWorldUser;
          newCompanyReminder.channel = this.companyContact.feed;
        }

        //Aggiorno contatto aziendale
        this.companyContact.lastFeedUpdate = this.$moment().unix();
        this.companyContact.lastFeedDate = this.getLastFeedDate(
          this.companyContact,
          msgCompany
        );
        this.$store.dispatch("contacts/update", {
          vlf: this.$vlf("contacts"),
          objs: [this.companyContact]
        });
      }
      try {
        if (this.edit && !Number.isInteger(this.msg.idWorldMessage)) {
          throw new Error("continue offline...");
        }
        const response = await this.$http.post(
          "contact/addMessage",
          {
            companyContactId: this.companyContact
              ? this.companyContact.idContactsContact
              : null,
            contactId: this.contact.idContactsContact,
            msg: this.msg,
            msgCompany,
            addReminder: addReminder,
            newReminder: newReminder,
            pauseDate: pauseDate ? pauseDate : null
          },
          {
            withCredentials: true
          }
        );
        if (response && response.data) {
          await Promise.all([
            this.$store.dispatch("messages/update", {
              vlf: this.$vlf("messages"),
              objs: response.data.msg
            }),
            //only if reminder
            this.$store.dispatch("events/update", {
              vlf: this.$vlf("events"),
              objs: response.data.events
            }),
            //solo se presente il contatto aziendale associato
            this.$store.dispatch("contacts/update", {
              vlf: this.$vlf("contacts"),
              objs: response.data.contacts
            }),
          ]);
        } else {
          await Promise.resolve();
        }
      } catch (e) {
        //se è un nuovo feed creo un id e dichiaro il channel
        if (!this.edit) {
          this.msg.channel = this.contact.feed;
        }
        /* Creazione  offline */
        await Promise.all([
          this.$store.dispatch("messages/update", {
            vlf: this.$vlf("messages"),
            objs: [this.msg, msgCompany, newReminder, newCompanyReminder]
          }),
          this.$store.dispatch("offline/saveSyncTuple", {
            _vue: this,
            _class: "ContactsContact",
            _table: "contacts",
            mode: "edit",
            type: "obj",
            obj: this.contact
          }),
          this.companyContact && !this.edit && addReminder
            ? this.$store.dispatch("offline/saveSyncTuple", {
                _vue: this,
                _class: "WorldMessage",
                _table: "messages",
                mode: "new",
                type: "obj",
                obj: newCompanyReminder
              })
            : "",
          //Tupla messaggio contatto aziendale
          this.companyContact && !this.edit
            ? this.$store.dispatch("offline/saveSyncTuple", {
                _vue: this,
                _class: "WorldMessage",
                _table: "messages",
                mode: "new",
                type: "obj",
                obj: msgCompany
              })
            : "",
          this.$store.dispatch("offline/saveSyncTuple", {
            _vue: this,
            _class: "WorldMessage",
            _table: "messages",
            mode: this.edit ? "edit" : "new",
            type: "obj",
            obj: this.msg
          }),
          //Creazione veloce reminder
          addReminder
            ? this.$store.dispatch("offline/saveSyncTuple", {
                _vue: this,
                _class: "WorldMessage",
                _table: "messages",
                mode: "new",
                type: "obj",
                obj: newReminder
              })
            : "",
          // Tupla contatto aziendale
          this.companyContact && !this.edit
            ? this.$store.dispatch("offline/saveSyncTuple", {
                _vue: this,
                _class: "ContactsContact",
                _table: "contacts",
                mode: "edit",
                type: "obj",
                obj: this.companyContact
              })
            : "",
        ]);
      } finally {
        if (
          this.selectedContactStatus != this.oldContactStatus &&
          this.msg.data.type != "reminder" &&
          !this.edit
        ) {
          this.changeStatus();
        } else {
          this.$anm22.eventBus.$emit("wg-modal-close");
        }
      }
    },
    async changeStatus() {
      let contactId = this.contact.idContactsContact;
      let msgData = {
        text: this.statusChangedText,
        description: "",
        type: "changeStatus",
        contentType: "plain",
        fromStatus: this.oldContactStatus,
        toStatus: this.selectedContactStatus
      };
      if (this.companyContact) {
        contactId = this.companyContact.idContactsContact;
      }
      try {
        const response = await this.$http.post(
          "contact/change-status",
          {
            contactId: contactId,
            newStatus: this.selectedContactStatus,
            ts: this.nowTimestamp - 1,
            msgData: msgData
          },
          {
            withCredentials: true
          }
        );
        this.$store.dispatch("contacts/update", {
          vlf: this.$vlf("contacts"),
          objs: [response.data.contact]
        });
        this.$store.dispatch("messages/update", {
          vlf: this.$vlf("messages"),
          objs: [response.data.message]
        });
          /* Messaggio creazione progetti */
        let engText = "";
        let itText = "";
        if(response.data.projects && response.data.projects.length > 0) {
          engText = " - Successfully created projects";
          itText = " - Progetti creati correttamente";
        }
        this.$anm22.eventBus.$emit("world-headbar-show-message", {
          text: this.$anm22.strLang(
            this.lang,
            "Contact status changed successfully" + engText,
            "Stato del contatto cambiato con successo" + itText
          ),
          type: "suggestion"
        });
      } catch (e) {
        console.log(e);
      } finally {
        this.$anm22.eventBus.$emit('wg-modal-close');
      }
    },
    getLastFeedDate(contact, msg) {
      let msgs = this.$store.getters["messages/getByChannel"](contact.feed);
      let lastInteraction = 0;
      if (msg.data.type != "reminder") {
        if(msg.data.callResponse && msg.data.callResponse == 'notexist') {
          lastInteraction = 0;
        } else {
          lastInteraction = msg.ts;
        }
      }
      msgs.forEach((contactMsg) => {
        if (
          contactMsg.idWorldMessage != msg.idWorldMessage &&
          contactMsg.data.type != "reminder" &&
          contactMsg.data.type != "changeStatus"
        ) {
          if(!contactMsg.data.callResponse || (contactMsg.data.callResponse && contactMsg.data.callResponse != 'notexist')) {
            if (contactMsg.ts > lastInteraction) {
              lastInteraction = contactMsg.ts;
            }
          } 
        }
      });
      if (lastInteraction == 0) {
        lastInteraction = "";
      }
      return lastInteraction;
    },
    parseDuration(string) {
      //Parsing della stringa per settare la durata
      const regex = /\d*([:. ][0-5]?\d)?([:. ][0-5]?\d)?/;
      if (regex.test(string)) {
        let hours = 0,
          minutes = 0;
        let parts = [];
        if (string.includes(":")) {
          parts = string.split(":");
          hours = parts[0];
          minutes = parts[1];
        } else if (string.includes(".")) {
          parts = string.split(".");
          hours = parts[0];
          minutes = parts[1];
        } else if (string.includes(" ")) {
          parts = string.split(" ");
          hours = parts[0];
          minutes = parts[1];
        } else {
          hours = string;
        }
        const result = Number(hours * 3600 + minutes * 60);
        this.msg.data.duration = result;
        this.duration = this.formatDuration(result);
      } else {
        console.log("error in parsing");
        return null;
      }
    },
    formatDuration(seconds) {
      const moment = this.$moment.utc(
        this.$moment.duration(seconds, "seconds").asMilliseconds()
      );
      const format = [
        moment.hours() !== 0 ? "H [h]" : "",
        moment.minutes() !== 0 ? "m [min]" : "",
        moment.seconds() !== 0 ? "s [s]" : "",
      ].join(" ");
      return moment.format(format);
    },
    durationToExpr() {
      this.duration = this.msg.data.duration
        ? Math.floor(this.msg.data.duration / 3600) +
          ":" +
          Math.floor((this.msg.data.duration % 3600) / 60)
        : "";
    }
  },
  created() {
    if (this.msg.data.category) {
      this.category = this.msg.data.category;
    } else if (!this.msg.data.category || this.msg.data.category == "") {
      this.category = "other";
    }
    if (this.msg.data.callResponse && this.msg.data.callResponse != "") {
      this.callOutcome = this.msg.data.callResponse;
    }
    if (this.msg.data.duration) {
      this.durationToExpr();
      this.parseDuration(this.duration);
    }
    if (
      (this.msg.idWorldMessage && this.msg.data.modeFrom == undefined) ||
      this.msg.data.modeFrom == "new"
    ) {
      this.modeFrom = "new";
    }
    if (
      (this.msg.idWorldMessage && this.msg.data.modeTo == undefined) ||
      this.msg.data.modeTo == "new"
    ) {
      this.modeTo = "new";
    }
    if (!this.msg.data.from) {
      this.msg.data.from = "";
    }
    if (!this.msg.data.to) {
      this.msg.data.to = "";
    }
    let otherContacts = [];
    let otherPhones = [];
    let otherEmails = [];
    if (this.contact.otherContacts.phones) {
      otherPhones = this.contact.otherContacts.phones.slice(0);
    }
    if (this.contact.otherContacts.emails) {
      otherEmails = this.contact.otherContacts.emails.slice(0);
    }
    let phoneContactAreaCode = this.contact.phoneAreaCode;
    let phoneContactNumber = this.contact.phoneNumber;
    if (phoneContactAreaCode && phoneContactNumber) {
      this.allContacts.push({
        label: {
          phoneAreaCode: phoneContactAreaCode,
          phoneNumber: phoneContactNumber,
        },
      });
    }
    let email = this.contact.email;
    if (otherPhones.length > 0) {
      otherPhones.forEach((element) => {
        this.allContacts.push({
          label: {
            phoneAreaCode: element.phoneAreaCode,
            phoneNumber: element.phoneNumber,
          },
        });
      });
    }
    if (otherEmails.length > 0) {
      otherEmails.forEach((email) => {
        this.allContacts.push({
          label: {
            email: email.address,
          },
        });
      });
    }
    if (email) {
      this.allContacts.push({ label: { email: email } });
    }
    this.selectedContactStatus = this.contact.status;
    this.oldContactStatus = this.contact.status;
  }
};
</script>

<style lang="scss" scoped>
.reminder-label {
  padding: 6px;
  font-size: 14px;
  cursor: pointer;
  border: 1px solid #666;
  color: #666;
  border-radius: 4px;
  margin-left: 10px;
}
.reminder-label .name {
  font-size: 15px;
  color: #666;
  display: inline-block;
  vertical-align: middle;
}
.reminder-label .img {
  display: inline-block;
  vertical-align: middle;
  margin-left: 3px;
}
.reminder-label.selected {
  background-color: #666;
  border: 1px solid #eee;
  &.reminder-label .name {
    color: #eee;
  }
}
.type-icon-div {
  cursor: pointer;
  padding: 5px;
  margin: 0 10px;
  border-bottom: 2px solid #fff;
  &:hover {
    border-bottom: 2px solid #ddd;
  }
  &.selected {
    border-bottom: 2px solid #0aabf4;
  }
}
.type-icon {
  width: 30px;
  height: 30px;
  border-radius: 50%;
  padding: 5px;
}
.description {
  margin: 0;
  max-width: none;
}
.input-row {
  flex-wrap: nowrap;
  align-items: center;
  margin-bottom: 10px;
}
.label-input-radio {
  display: block;
  height: 20px;
  width: 20px;
  border: 1px solid #bbb;
  border-radius: 4px;
  font-size: 16px;
  padding: 1px 2px;
  cursor: pointer;
}
</style>
